export default "__VITE_ASSET__yrAa9Ddj__"